import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSeo, seoMeta, serializeSchema } from './site';

export default function PageSeo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const seo = getSeo(pathname);
    document.title = seo.title;
    document.documentElement.lang = seo.lang;
    for (const [attribute, key, value] of seoMeta(seo)) {
      const existing = [...document.head.querySelectorAll<HTMLMetaElement>(`meta[${attribute}="${key}"]`)];
      const element = existing.shift() ?? document.createElement('meta');
      existing.forEach(duplicate => duplicate.remove());
      if (value === undefined) { element.remove(); continue; }
      element.setAttribute(attribute, key);
      element.content = value;
      if (!element.isConnected) document.head.appendChild(element);
    }
    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach(link => link.remove());
    for (const alt of seo.alternates) {
      const link = document.createElement('link');
      link.rel = 'alternate'; link.hreflang = alt.hreflang; link.href = alt.href;
      document.head.appendChild(link);
    }
    const canonicals = [...document.head.querySelectorAll<HTMLLinkElement>('link[rel="canonical"]')];
    const canonical = canonicals.shift() ?? document.createElement('link');
    canonicals.forEach(duplicate => duplicate.remove());
    if (seo.canonical) {
      canonical.rel = 'canonical';
      canonical.href = seo.canonical;
      if (!canonical.isConnected) document.head.appendChild(canonical);
    } else canonical.remove();
    const schema = document.getElementById('page-schema') ?? document.createElement('script');
    if (seo.schema) {
      schema.id = 'page-schema';
      schema.setAttribute('type', 'application/ld+json');
      schema.textContent = serializeSchema(seo.schema);
      if (!schema.isConnected) document.head.appendChild(schema);
    } else schema.remove();
  }, [pathname]);
  return null;
}
